/* eslint-disable no-unused-vars */
import React from 'react';
import ASessions1 from './sessions/a_sessions_1';
import ASessions5 from './sessions/a_sessions_5';
import ASessions10 from './sessions/a_sessions_10';
import ASessions25 from './sessions/a_sessions_25';
import ASessions50 from './sessions/a_sessions_50';
import ASessions100 from './sessions/a_sessions_100';
import ASessions200 from './sessions/a_sessions_200';
import ADSessions1 from './sessions/ad_sessions_1';
import ADSessions5 from './sessions/ad_sessions_5';
import ADSessions10 from './sessions/ad_sessions_10';
import ADSessions25 from './sessions/ad_sessions_25';
import ADSessions50 from './sessions/ad_sessions_50';
import ADSessions100 from './sessions/ad_sessions_100';
import ADSessions200 from './sessions/ad_sessions_200';
import AWeekStreak1 from './week_streak/a_week_streak_1';
import AWeekStreak2 from './week_streak/a_week_streak_2';
import AWeekStreak3 from './week_streak/a_week_streak_3';
import AWeekStreak5 from './week_streak/a_week_streak_5';
import AWeekStreak10 from './week_streak/a_week_streak_10';
import AWeekStreak20 from './week_streak/a_week_streak_20';
import ADWeekStreak1 from './week_streak/ad_week_streak_1';
import ADWeekStreak2 from './week_streak/ad_week_streak_2';
import ADWeekStreak3 from './week_streak/ad_week_streak_3';
import ADWeekStreak5 from './week_streak/ad_week_streak_5';
import ADWeekStreak10 from './week_streak/ad_week_streak_10';
import ADWeekStreak20 from './week_streak/ad_week_streak_20';

import AAlphaPosse from './profile/a_alpha-posse';
import AProfileCompleted from './profile/a_profile_completed';
import ATrainingLog from './profile/a_training_log';
import ADAlphaPosse from './profile/ad_alpha_posse';
import ADProfileCompleted from './profile/ad_profile_completed';
import ADTrainingLog from './profile/ad_training_log';

const buildAchievementKey = (typeId, value) => {
  const safeType = Number(typeId);
  const safeValue = value === null || typeof value === 'undefined' ? 'null' : Number(value);
  return `${safeType}:${safeValue}`;
};

const normalizeAchievementName = name =>
  typeof name === 'string' ? name.trim().toLowerCase() : '';

export const ACHIEVEMENT_ICON_STATES = {
  earned: 'earned',
  normal: 'normal',
};

export const InlineAchievementIcon = ({ className, html }) => {
  const containerRef = React.useRef(null);

  React.useEffect(() => {
    if (containerRef.current) {
      containerRef.current.innerHTML = html || '';
    }
  }, [html]);

  return <div className={className} ref={containerRef} aria-hidden="true" />;
};

const achievementIconRegistry = {
  [buildAchievementKey(1, 1)]: {
    earned: ASessions1,
    normal: ADSessions1,
  },
  [buildAchievementKey(1, 5)]: {
    earned: ASessions5,
    normal: ADSessions5,
  },
  [buildAchievementKey(1, 10)]: {
    earned: ASessions10,
    normal: ADSessions10,
  },
  [buildAchievementKey(1, 25)]: {
    earned: ASessions25,
    normal: ADSessions25,
  },
  [buildAchievementKey(1, 50)]: {
    earned: ASessions50,
    normal: ADSessions50,
  },
  [buildAchievementKey(1, 100)]: {
    earned: ASessions100,
    normal: ADSessions100,
  },
  [buildAchievementKey(1, 200)]: {
    earned: ASessions200,
    normal: ADSessions200,
  },
  [buildAchievementKey(2, 1)]: {
    earned: AWeekStreak1,
    normal: ADWeekStreak1,
  },
  [buildAchievementKey(2, 2)]: {
    earned: AWeekStreak2,
    normal: ADWeekStreak2,
  },
  [buildAchievementKey(2, 3)]: {
    earned: AWeekStreak3,
    normal: ADWeekStreak3,
  },
  [buildAchievementKey(2, 5)]: {
    earned: AWeekStreak5,
    normal: ADWeekStreak5,
  },
  [buildAchievementKey(2, 10)]: {
    earned: AWeekStreak10,
    normal: ADWeekStreak10,
  },
  [buildAchievementKey(2, 20)]: {
    earned: AWeekStreak20,
    normal: ADWeekStreak20,
  },
  [buildAchievementKey(4, 3)]: {
    earned: AAlphaPosse,
    normal: ADAlphaPosse,
  },
  [buildAchievementKey(4, 1)]: {
    earned: ATrainingLog,
    normal: ADTrainingLog,
  },
  [buildAchievementKey(4, 4)]: {
    earned: AProfileCompleted,
    normal: ADProfileCompleted,
  },
  [buildAchievementKey(5, null)]: {
    earned: AProfileCompleted,
    normal: ADProfileCompleted,
  },
};

const achievementIconByName = {
  [normalizeAchievementName('AP Member')]: {
    earned: AAlphaPosse,
    normal: ADAlphaPosse,
  },
  [normalizeAchievementName('Training Logged')]: {
    earned: ATrainingLog,
    normal: ADTrainingLog,
  },
  [normalizeAchievementName('Profile Completed')]: {
    earned: AProfileCompleted,
    normal: ADProfileCompleted,
  },
};

const getAchievementIconByTypeAndValue = (typeId, timesValue, state) => {
  const key = buildAchievementKey(typeId, timesValue);
  return achievementIconRegistry[key]?.[state] || null;
};

const getAchievementIconByName = (name, state) => {
  const normalizedName = normalizeAchievementName(name);

  if (!normalizedName) {
    return null;
  }

  return achievementIconByName[normalizedName]?.[state] || null;
};

export const getAchievementIconComponent = (
  typeOrAchievement,
  timesValue,
  state = ACHIEVEMENT_ICON_STATES.normal,
) => {
  // Support passing a full achievement object to resolve by name or type/timesValue
  if (typeOrAchievement && typeof typeOrAchievement === 'object') {
    const achievement = typeOrAchievement;
    const resolvedState = typeof timesValue === 'string' ? timesValue : state;

    const matchByName = getAchievementIconByName(achievement.name, resolvedState);
    if (matchByName) {
      return matchByName;
    }

    let valueToUse;
    if (typeof timesValue === 'string') {
      valueToUse = achievement.timesValue;
    } else if (typeof timesValue !== 'undefined') {
      valueToUse = timesValue;
    } else {
      valueToUse = achievement.timesValue;
    }

    return getAchievementIconByTypeAndValue(achievement.type, valueToUse, resolvedState);
  }

  return getAchievementIconByTypeAndValue(typeOrAchievement, timesValue, state);
};

export default achievementIconRegistry;
